import React from 'react';
import { Typography } from '@mui/material';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Product template
 */
export const ProductTemplate: React.FC<{ product: string | null | undefined }> = ({ product }) => (
  <Typography variant="body2">{product || '-'}</Typography>
);

// Template function for grid column
export const productTemplate = (rowData: ContractView) => (
  <ProductTemplate product={rowData.product} />
);

export default ProductTemplate;
